import { c as _c } from "react/compiler-runtime";
import { ComponentProps, PropsWithChildren, ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { cva } from 'class-variance-authority';
const tagbuttonVariants = cva('inline-flex items-center justify-center whitespace-nowrap gap-[6px] rounded-lg px-2 py-[10px] lg:gap-2 lg:px-4 lg:py-3 subheader-3 lg:subheader-1', {
  variants: {
    tagActive: {
      /** Blue Button */
      active: 'bg-vive-brand-50 text-vive-white',
      /** Outline Button */
      inactive: 'bg-[#212A39] hover:bg-vive-primary-70 text-vive-primary-20'
    }
  },
  defaultVariants: {
    tagActive: 'inactive'
  }
});
interface TagButtonProps extends PropsWithChildren<ComponentProps<typeof Button>> {
  tagIcon: ReactNode;
  active?: boolean;
}
function TagButton(t0) {
  const $ = _c(20);
  let children;
  let className;
  let props;
  let ref;
  let t1;
  let tagIcon;
  if ($[0] !== t0) {
    ({
      tagIcon,
      active: t1,
      className,
      ref,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = ref;
    $[5] = t1;
    $[6] = tagIcon;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    ref = $[4];
    t1 = $[5];
    tagIcon = $[6];
  }
  const active = t1 === undefined ? false : t1;
  let t2;
  if ($[7] !== active || $[8] !== className) {
    t2 = cn(tagbuttonVariants({
      tagActive: active ? "active" : "inactive"
    }), className);
    $[7] = active;
    $[8] = className;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== tagIcon) {
    t3 = <div className="size-[20px] lg:size-[24px]">{tagIcon}</div>;
    $[10] = tagIcon;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== children) {
    t4 = <div className="h-[20px] w-fit leading-5 lg:h-[24px] lg:leading-6">{children}</div>;
    $[12] = children;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== props || $[15] !== ref || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
    t5 = <Button variant="ghost" size="custom" className={t2} ref={ref} {...props}>{t3}{t4}</Button>;
    $[14] = props;
    $[15] = ref;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}
export default TagButton;